module.exports = __webpack_public_path__ + "img/share-image.1cee680b.svg";